export function getTextAlign(transformer) {
    return Object.freeze({
        left: transformer.textAlign('left'),
        center: transformer.textAlign('center'),
        right: transformer.textAlign('right'),
    });
}
